// Navigation constants
export const NAVIGATION_CONSTANTS = {
  // Height and spacing
  NAV_HEIGHT: 80,
  SCROLL_TIMEOUT: 100,
  
  // Animation timing
  GLASS_TRANSITION_DURATION: 900,
  GLASS_CUBIC_BEZIER: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  
  // Scroll optimization
  SCROLL_THROTTLE_DELAY: 16, // ~60fps
  SCROLL_DEBOUNCE_DELAY: 150,
  
  // Theme detection
  THEME_PROBE_OFFSET: 10,
  THEME_DEBOUNCE_DELAY: 50
};

// CSS custom properties for consistent styling
export const CSS_CUSTOM_PROPERTIES = {
  '--nav-height': `${NAVIGATION_CONSTANTS.NAV_HEIGHT}px`,
  '--transition-duration': `${NAVIGATION_CONSTANTS.GLASS_TRANSITION_DURATION}ms`,
  '--transition-timing': NAVIGATION_CONSTANTS.GLASS_CUBIC_BEZIER
};